function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1024 17.767c-64.254 5.683-91.796-3.41-218.834-6.331C708.63 9.215 590.595 24 416.835 24 346.204 24 228.96 10.653 166.364 9.215 61.292 6.801 0 13.387 0 13.387V0h1024v17.767z",
  fill: "#235544"
});

function SvgProductStepsBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgdmlld0JveD0iMCAwIDEwMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMDI0IDE3Ljc2NzFDOTU5Ljc0NiAyMy40NTAzIDkzMi4yMDQgMTQuMzU3OCA4MDUuMTY2IDExLjQzNTZDNzA4LjYzIDkuMjE0OTkgNTkwLjU5NSAyNCA0MTYuODM1IDI0QzM0Ni4yMDQgMjQgMjI4Ljk2IDEwLjY1MjkgMTY2LjM2NCA5LjIxNDk5QzYxLjI5MTcgNi44MDEzOCAwIDEzLjM4NyAwIDEzLjM4N1YwSDEwMjRWMTcuNzY3MVoiIGZpbGw9IiMyMzU1NDQiLz4KPC9zdmc+Cg==";
export { SvgProductStepsBottom as ReactComponent };